export class TabItem {
    constructor() {
        this.IsLoaded = false;
    }
    public $Panel: JQuery;
    public $Header: JQuery;
    public IsSelected: boolean;
    public IsLoaded: boolean;
}
